import { Component, h, Host, Prop } from "@stencil/core";

@Component({
  tag: "f-flyout-message",
  styleUrl: "f-flyout-message.scss",
  shadow: true,
})
export class FlyoutMessage {
  @Prop() messageLabel: string;

  render() {
    return (
      <Host>
        <div class="flyout-message" data-test="flyout-message">
          <span class="flyout-message__label">{this.messageLabel}</span>
        </div>
      </Host>
    );
  }
}
